import { SET_PROFIL, SET_MY_MEDICI, SET_RID } from './ProfilMutations'

import api from '@/api'

export default {
  loadProfil ({ commit }, payload) {
    api
      .loadProfil()
      .then(response => commit(SET_PROFIL, response))
      .catch(error => {
        console.log('Error: ', error)
      })
  },
  loadMyMedici ({ commit }, payload) {
    api
      .loadMediciCabinet()
      .then(response => commit(SET_MY_MEDICI, response))
      .catch(error => {
        console.log('Error: ', error)
      })
  },
  loadRid ({commit}, payload) {
    api
      .loadRid()
      .then(response => commit(SET_RID, response))
      .catch(error => {
        console.log('Error: ', error)
      })
  }
}



// WEBPACK FOOTER //
// ./src/store/modules/profil/ProfilActions.js